var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTicketActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      transform: "translateY(-1px)"
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.932,
    height: 22.932,
    viewBox: "0 0 22.932 22.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-ticket",
    d: "M20.1,5.743l-.475.475a2.055,2.055,0,0,1-2.907-2.907l.475-.475L14.353,0,0,14.353l2.836,2.836.475-.475A2.055,2.055,0,0,1,6.218,19.62l-.475.475,2.836,2.836L22.932,8.579ZM7.6,20.049a3.4,3.4,0,0,0-4.714-4.714L1.9,14.353,14.353,1.9l.982.982A3.4,3.4,0,0,0,20.049,7.6l.982.982L8.579,21.031Z",
    transform: "translate(0)",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTicketActive);
export default __webpack_public_path__ + "static/media/icon-ticket-active.2abd5bcf6e2f3f1018236c6b3819673b.svg";
export { ForwardRef as ReactComponent };